import { AddTreatmentRequestPayload } from "@/data/payload/treatment/add-treatment-request-payload";
import { AddTreatmentResponseEntity } from "@/domain/entity/treatment/add-treatment-response-entity";
import { TreatmentStepInfoEntity } from "@/domain/entity/treatment/treatment-step-info-entity";
import { TreatmentRepository } from "@/domain/repository/treatment-repository";
import { formatLocalToYyyyMmDd } from "@/utils/date-util";
import { TreatmentType } from "@/utils/enum/treatment-type-enum";
import { SATError, SATResult } from "@sadtx/sat-error";

export class AddTreatmentUsecase {
  private maxVisitDateWeekRange = 4;

  //MARK:- Constructor
  constructor(private readonly treatmentRepo: TreatmentRepository) {}

  //MARK:- execute
  async execute(
    patientUuid: string,
    memo: string,
    treatmentStepInfo: TreatmentStepInfoEntity | null,
    treatmentType: TreatmentType
  ): Promise<SATResult<AddTreatmentResponseEntity, SATError>> {
    console.log("[AddTreatmentUsecase] :: execute :: patientUuid", patientUuid);
    console.log("[AddTreatmentUsecase] :: execute :: memo", memo);

    const startDate = new Date();
    const treatmentDuration = this.getSelectedTreatmentDurationByType(treatmentType);
    const endDate = new Date(startDate);
    endDate.setDate(endDate.getDate() + treatmentDuration * 7);

    const payload: AddTreatmentRequestPayload = {
      patientUuid,
      step: (treatmentStepInfo?.step ?? 0) + 1,
      type: treatmentDuration,
      startDate: formatLocalToYyyyMmDd(startDate),
      endDate: formatLocalToYyyyMmDd(endDate),
      memo,
      repeatIds: null,
    };

    console.log("[AddTreatmentUsecase] :: execute :: payload", payload);
    const result = await this.treatmentRepo.addTreatment(payload);

    if (result.isFailure) {
      console.error("[AddTreatmentUsecase] :: execute :: error", result.error);
      return SATResult.failure(result.error);
    }

    console.log("[AddTreatmentUsecase] :: execute :: success");
    return SATResult.success(result.value!);
  }

  private getSelectedTreatmentDurationByType(treatmentType: TreatmentType): number {
    switch (treatmentType) {
      case TreatmentType.WEEK_14:
        return 14;
      case TreatmentType.WEEK_28:
        return 28;
      default:
        console.error(
          "[AddTreatmentUsecase] :: getSelectedTreatmentDurationByType :: 정의되지 않은 치료 타입입니다. switch 문 추가 필요",
          treatmentType
        );
        return 14;
    }
  }
}
